import { MarketingConsent } from '@iheartjane/menu';
import {
  Box,
  Button,
  CheckboxField,
  Flex,
  JaneGoldShadowLogo,
  JaneLogo,
  JanePayLogoWhite,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';
import { useState } from 'react';

import { Background } from './SuccessScreen.styles';

interface SuccessScreenProps {
  onDoneClick(optOut?: boolean): void;
  storeHasJaneGold: boolean;
  storeHasWhiteLabel: boolean;
  storePhoto?: string | null;
}

export const SuccessScreen = ({
  storeHasJaneGold,
  storeHasWhiteLabel,
  onDoneClick,
  storePhoto,
}: SuccessScreenProps) => {
  const [optOut, setOptOut] = useState(false);

  return (
    <Flex
      flexDirection="column"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Box background="gold-light" height={160} width="100%">
        <Background
          sparkly={storeHasJaneGold}
          hideBranding={storeHasWhiteLabel}
        >
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
          >
            {storeHasJaneGold && (
              <>
                <JaneLogo size="xs" />
                <JaneGoldShadowLogo height="55px" />
              </>
            )}
            {!storeHasJaneGold && storeHasWhiteLabel && (
              <PartnerLogo
                name="store-logo"
                variant="store"
                image={storePhoto}
              />
            )}
            {!storeHasJaneGold && !storeHasWhiteLabel && (
              <Box background="purple" width="100%">
                <JanePayLogoWhite my={56} height="48px" />
              </Box>
            )}
          </Flex>
        </Background>
      </Box>
      <Flex flexDirection="column" p={24}>
        <Typography branded textAlign="left" variant="title-bold" mb={16}>
          {storeHasJaneGold
            ? 'You successfully linked your bank account and joined Jane Gold'
            : storeHasWhiteLabel
              ? 'Success!'
              : 'Welcome to Jane Pay'}
        </Typography>
        <Typography textAlign="left" mb={16}>
          {storeHasJaneGold
            ? 'You can now earn cash back with Jane Gold and enjoy faster shopping with Jane Pay at the kiosk and more locations using Jane Pay. Go back to the kiosk and start shopping!'
            : storeHasWhiteLabel
              ? 'You successfully linked your bank account to check out on Jane and other participating cannabis stores, powered by Jane and Aeropay. Go back to the kiosk and start shopping!'
              : 'You successfully linked your bank account. You can now use Jane Pay to checkout on Jane and other participating cannabis stores. Go back to the kiosk and start shopping!'}
        </Typography>
        {storeHasJaneGold && (
          <>
            <Flex mb={16} width="100%">
              <CheckboxField
                disableMobileInputStyling
                name="promotionsOptIn"
                label="Jane Gold promotional emails"
                labelHidden
                defaultChecked
                onChange={(value) => setOptOut(!value)}
              />
              <MarketingConsent />
            </Flex>
            <Button
              full
              label="Done"
              onClick={() => onDoneClick(optOut)}
              size="small"
              variant="primary"
            />
          </>
        )}
      </Flex>
    </Flex>
  );
};
